import React, { useState } from "react";
import { Box } from "@mui/material";

import { DocumentByIdDTO, UtilityBillByIdDTO } from "api";
import { MaybeNull } from "types";
import { Loading, PdfFooter, PdfPreview } from "components";

import { AddDataEntryWrapper, UtilityBillForm } from "./components";

export const BillModal: React.FC<{
  document: DocumentByIdDTO | UtilityBillByIdDTO;
  isLoading: boolean;
  onClose: () => void;
  billId?: MaybeNull<string>;
}> = ({
  document,
  isLoading,
  onClose,
  billId = null,
}) => {
    const [scaleChange, setScaleChange] = useState<boolean>(false);
    const [scale, setScale] = useState<number>(0.75);

    const { downloadUrl, fileName } = document as DocumentByIdDTO;

    if (scale <= 0.25) {
      setScale(0.75);
    };

    if (isLoading || !document) {
      return <Loading />;
    };

    return (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
          }}
        >
          <Box
            sx={{
              width: "40%",
              "> div": {
                width: "100% !important",
                height: "calc(100vh - 74px) !important",
                "> div": {
                  width: "100% !important",
                  minWidth: "100% !important",
                  height: "100%",
                  padding: 0,
                  "> div": {
                    width: "100% !important",
                    height: "100%",
                  },
                },
              },
            }}
          >
            <PdfPreview
              downloadUrl={downloadUrl}
              scale={scale}
              isScaleChange={scaleChange}
              billId={billId}
            />
          </Box>
          <Box
            sx={{
              width: "60%",
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              padding: 3,
            }}
          >
            {billId
              ? <UtilityBillForm utilityBill={document as UtilityBillByIdDTO} onClose={onClose} billId={billId} />
              : <AddDataEntryWrapper document={document as DocumentByIdDTO} onClose={onClose} />
            }
          </Box>
        </Box>
        <PdfFooter
          fileName={fileName}
          setScale={setScale}
          downloadUrl={downloadUrl as string}
          actionsDisabled={isLoading}
          setScaleChange={setScaleChange}
        />
      </Box>
    );
  };
